import script from "./AnnouncementTypeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementTypeDetail.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementTypeDetail.vue?vue&type=style&index=0&id=0a017ac3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a017ac3"]])

export default __exports__